var QUEUE_TYPE = {
    Sync    :'Sync',
    Parallel:'Parallel',
    Relevant:'Relevant'
}
var Queue = function(){
    this.queueArr = [];
    this.QueueType = '';
    this.onceStarted = false;
}

/**
 * 串行，同步运行队列
 */
Queue.prototype.setSync = function(){
    this.QueueType = QUEUE_TYPE.Sync;
    this.onceStarted = false;
    this.done = function(res){
        
        var next = this.queueArr.shift();

        if( this.queueArr.length <= 0 ){
            this.onceStarted = false;
        }
        if('function' == typeof next ){
        //   setTimeout(function(){
            // 这个属于基础方法，应该是稳定的【删除】
            // if(window.logInfo){
            //     logInfo('queue.done','queue item dequeueed');
            // }
            next.call(this,res);
        //   }.bind(this),1);
        }
    }.bind(this);
};
var _runSync = function(qInctance,fn){
    
    if('function' == typeof fn){
        qInctance.queueArr.push(fn);
    
        if(false === qInctance.onceStarted ){
            var firstFn = qInctance.queueArr.shift();
            if('function' == typeof firstFn ){

                qInctance.onceStarted = true;
                // setTimeout(function(){
                    firstFn.call(qInctance);
                // },1);            
            }else{
                throw 'fatal error for no function in queue';
            }
        }
    }    
};

/**
 * 并行，并发运行队列
 */
Queue.prototype.setParallel = function(){
    this.QueueType = QUEUE_TYPE.Parallel;
    this.done = function(res){
    }.bind(this);
};


var _runParallel = function(qInctance,fn){
    if('function' == typeof fn ){
        fn.call(qInctance);
    }else{
        throw 'faltal error for no function in queue';
    }
};

/**
 * 相关联队列。。除第一个外，所有成员都依赖第一个函数的结果 ，也就是
 * 第一个与剩下的 串行。剩下的自己并发。
 */
Queue.prototype.setRelevant = function(){
    this.QueueType = QUEUE_TYPE.Relevant;
    this.onceStarted = false;
    this.done = function(res){

        if( this.queueArr.length > 0){
            this.queueArr[0].backFn.call(this,res);
            this.queueArr.shift();
        }
        var next = null;
        while(next = this.queueArr.shift() ){
            if('function' == typeof next.backFn ){
                next.backFn.call(this,res);
            }
        }
        //一次必定清空队列。所以下次就必须 为 false。
        this.onceStarted = false;
    }.bind(this);
};
/**
 * {
                fn      :fn,
                backFn  :fn
            }
 */
var _runRelevant = function(qInctance,fnObj){
    qInctance.queueArr.push(fnObj);
    if(false === qInctance.onceStarted ){
        var firstFn = qInctance.queueArr[0];
        if(firstFn && 'function' == typeof firstFn.fn ){
            qInctance.onceStarted = true;

            setTimeout(function(){
                firstFn.fn.call(qInctance);
            },0);
            
        }else{
            console.error('_runRelevant:',firstFn,' is illegal');
        }
    }
};
Queue.prototype.run = function(fnOrObj){
    switch( this.QueueType ){
        case QUEUE_TYPE.Sync:
            _runSync(this,fnOrObj);
            break;
        case QUEUE_TYPE.Parallel:
            _runParallel(this,fnOrObj);
            break;
        case QUEUE_TYPE.Relevant:
            _runRelevant(this,fnOrObj);
            break;
    }
};

export default Queue;
/*
* @desc tester
*/

/**
 * usage:
 * 1、完全串行的队列。
  var lqueue = new Queue();
  lqueue.setSync();
  lqueue.run(functionA(){
       setTimeout(function(){
           console.log('run first');
           this.done(dataToNext) 或者 this.done();   //这句话一定要异步完成后，调用。
       }.bind(this),2000);
  });
  lqueue.run(functionB(data){
       setTimeout(function(){
           console.log('run second');
           console.log(data);
           this.done() //这句话一定要异步完成后，调用。
       }.bind(this),1000);
  });
 * 
 * 效果：在2s后，打印出run first，出了打印run first后，再过1s,打印出run second 和前一次调用 的dataToNext;
 * 如果直接调用 functionA,functionB,则我们会先打印出 run second,run first。其实这对于我们有依赖的调用 两次cgi的场景，是不合理的。
 * 
 * 2、相关联的队列。
 * 功能：对同一个异步操作，为了开了方便，我们一下子调用了N次，而这N次，只需要有一次返回了结果就可以。其它的N-1次 可以省略。
 * 比如我们的 getUinKey 函数。verifyJsapi。
 * e.g 1
  var lqueue = new LineQueue();
  lqueue.setRelevant();
  lqueue.run({
       fn:function(){
           setTimeout(function(){
               //e.g.这里是一个cgi调用。
               this.done({a:1});
           }.bind(this),2000);
       },
       backFn:function(data){
           console.log(data); //输出 {a:1}
       }
  });
  
 * e.g 2
  var lqueue = new LineQueue();
  lqueue.setRelevant();
  lqueue.run({
       fn:function(){
           wxBridge.getUinKey(function(login){
               this.done(login);
               //有了登陆态，就可以开始请求其它cgi咯。
           }.bind(this));
       },
       backFn:function(data){
           //有了登陆态，就可以开始请求其它cgi咯。
           //这里可以
       }
  });
  
 * 3、并发队列。 
  var lqueue = new LineQueue();
  lqueue.setParallel();
  lqueue.run(functionA(){
     console.log('a');  
  });
  lqueue.run(functionB(){
     console.log('B');  
  });
  
 * 这与  
 * functionA();
 * functionB()
 * 等 价。
 */
